"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var core_1 = require("@material-ui/core");
var CheckCircle_1 = require("@material-ui/icons/CheckCircle");
var react_intl_1 = require("react-intl");
var Translation_1 = require("../../../../../common/components/presentation/Translation/Translation");
var reserveOnlineMessageStyles_1 = require("./reserveOnlineMessageStyles");
var useCheckoutContext_1 = require("../../../../common/hooks/useCheckoutContext");
var date_fns_1 = require("date-fns");
var ReserveOnlineMessage = function () {
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var showConfirmationIcon = core_1.useTheme().checkoutLite.confirmation.showConfirmationIcon;
    var style = reserveOnlineMessageStyles_1.default();
    var intl = react_intl_1.useIntl();
    var deal = useCheckoutContext_1.default().deal;
    var latestTransaction = ((_a = deal) === null || _a === void 0 ? void 0 : _a.paymentInfo) ? (_b = deal) === null || _b === void 0 ? void 0 : _b.paymentInfo[((_c = deal) === null || _c === void 0 ? void 0 : _c.paymentInfo.length) - 1] : null;
    var latestTransactionId = (_d = latestTransaction) === null || _d === void 0 ? void 0 : _d.transactionId;
    var latestTransactionDate = ((_e = latestTransaction) === null || _e === void 0 ? void 0 : _e.transactionTime) ? new Date(parseInt((_f = latestTransaction) === null || _f === void 0 ? void 0 : _f.transactionTime))
        : new Date();
    var latestTransactionDateLabel = (_g = date_fns_1.format(latestTransactionDate, 'dd/MMM/yyyy hh:mm aa'), (_g !== null && _g !== void 0 ? _g : null));
    return (<core_1.Box data-test="container:confirmation_reserve_online:message">
      <core_1.Box display="flex" className={style.titleContainer}>
        {showConfirmationIcon && <CheckCircle_1.default className={style.icon}/>}
        <core_1.Typography component="h2" variant="body1" data-test="text:confirmation:title" className={style.title}>
          <Translation_1.default id={'trans__checkout__confirmation_page__title_reserve_journey'}/>
        </core_1.Typography>
      </core_1.Box>
      <core_1.Typography component="h2" variant="body1" data-test="text:confirmation:description1" className={style.description1}>
        <Translation_1.default id={'trans__checkout__confirmation_page__description1_reserve_online_journey'} values={{
        email: (<a className={style.email} href={"mailto:" + intl.formatMessage({
            id: 'trans__checkout__confirmation_page__email_on_description_reserve_online_journey',
        })}>
                <Translation_1.default id={'trans__checkout__confirmation_page__email_on_description_reserve_online_journey'}/>
              </a>),
    }}/>
      </core_1.Typography>
      <core_1.Typography component="h2" variant="body1" data-test="text:confirmation:description2" className={style.description2}>
        <Translation_1.default id={'trans__checkout__confirmation_page__description2_reserve_online_journey'} values={{
        email: (<a className={style.email} href={"mailto:" + intl.formatMessage({
            id: 'trans__checkout__confirmation_page__email_on_description_reserve_online_journey',
        })}>
                <Translation_1.default id={'trans__checkout__confirmation_page__email_on_description_reserve_online_journey'}/>
              </a>),
        order_number: (_h = deal) === null || _h === void 0 ? void 0 : _h.uuid,
        transaction_id: latestTransactionId,
        current_date: latestTransactionDateLabel,
        mobile_phone: (<a data-test="text:reserveOnline:mobilePhone" href={"tel:" + intl.formatMessage({ id: 'trans__checkout__confirmation_page__phone_in_description' })}>
                <Translation_1.default id="trans__checkout__confirmation_page__phone_in_description"/>
              </a>),
    }}/>
      </core_1.Typography>
    </core_1.Box>);
};
exports.default = ReserveOnlineMessage;
